import type React from "react";
import { useDrop } from "react-dnd";

type Props = {
	word: string;
	dropAreaIndex: number;
	droppedWords: { word: string; originalIndex: number }[];
	onDropWord: (
		dropAreaIndex: number,
		draggedWordObj: { word: string; index: number },
	) => void;
	onRemoveWord?: (index: number) => void;
	correct?: null | boolean;
};

export const DropArea: React.FC<Props> = ({
	word,
	dropAreaIndex,
	onDropWord,
	onRemoveWord,
	correct,
	droppedWords,
}) => {
	const [{ isOver }, drop] = useDrop({
		accept: "unscramble",
		drop: (item: { word: string; index: number }) => {
			onDropWord(dropAreaIndex, item);
			return item;
		},
		canDrop: () => droppedWords[dropAreaIndex].word === "",
		collect: (monitor) => ({
			isOver: !!monitor.isOver(),
		}),
	});

	function piantBackgound(correct: undefined | null | boolean) {
		if (correct === undefined) {
			return "";
		}
		return correct === false ? "-incorrect" : "-correct";
	}

	return (
		<div className="unscramble-activity__drop-item" ref={drop}>
			<button
				type="button"
				ref={drop}
				className={`unscramble-activity__dropped-word${piantBackgound(correct)}`}
				style={{ backgroundColor: isOver ? "lightgray" : "white" }}
				onClick={() => onRemoveWord && word && onRemoveWord(dropAreaIndex)}
			>
				{word}
			</button>
		</div>
	);
};
